import { useState, useMemo } from "react";

import styled from "styled-components";




import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


import logo1 from "./logo-1.png";
import logo6 from "./logo-6.png";



const Geral = styled.div`
  max-width: 100%;
  overflow: auto;
  
  background-color: transparent;
  border-radius: 12px;
  box-shadow: 0px 0px 2px #ccc;


  @media (max-width:1367px) {
    margin: 5px;
    box-shadow: none;

  }

  @media (max-width: 1024px) {
    margin: 5px;
    box-shadow: none;
    margin-bottom: 100px;
  }


`;


const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  font-family: 'Roboto', sans-serif;
  
  
`;

const Thead = styled.thead`
  background-color: #fff;

`;


export const Tbody = styled.tbody`
  background-color: #fefefe;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #e0e0e0;
  
  ${({ noHover }) =>
    !noHover &&
    `
    &:hover {
      background-color: #f5f5f5;
    }
  `}

  @media (max-width: 1024px) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

export const TrHead = styled.tr`
  border-bottom: 1px solid #e0e0e0;
  

  @media (max-width: 1024px) {
    .hide-on-mobile {
      display: none;
    }
  }
`;

export const Th = styled.th`
  color: #575757;
  padding: 18px 10px;
  font-size: 18px;
  text-align: center;
  font-weight: bold;

  cursor: pointer;
  &.hide-on-mobile {
    @media (max-width: 1024px) {
      display: none;
    }
  }





  @media (max-width: 1367px) {
    padding: 6px 5px;
    font-size: 12px;
  }
  @media (max-width: 1024px) {
    padding: 6px 5px;
    font-size: 12px;
  }

  @media (max-width: 780px) {
    padding: 6px 1px;
    font-size: 6px;
  }
`;



export const Td = styled.td`
  padding: 25px 10px;

  font-size: 18px;
  color: #575757;
  background-color: ${(props) => props.zebra ? "#f2f2f2" : "transparent"};
    text-align: center;
  white-space: nowrap; 
  overflow: hidden;     
  text-overflow: ellipsis; 

  &.mobile-hide {
    @media (max-width: 1024px) {
      display: none;
    }
  }
  @media (max-width: 1367px) {
    padding: 6px;
    font-size: 14px;
  }

  @media (max-width: 1024px) {
    padding: 6px;
    font-size: 12px;
  }

  @media (max-width: 780px) {
    padding: 6px 1px;
    font-size: 6px;
  }

`;

export const CabecalhoTabela = styled.th`
  text-align: center;
  
  padding: 18px;
  color: white;

  h2{
    font-size: 2rem;
  }

  padding{
    font-size: 1.4rem;
  }

  
`;

const Button = styled.button`
  background-color: #E5F7EE; // verde claro pastel
  color: #008000;            // verde forte
  font-size: 16px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #d3f0e2; // tom mais escuro no hover
  }

  @media (max-width: 780px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;


  h2 {
    margin: 0;
    font-size: 32px;
    color: #008000;
  }

  @media (max-width: 780px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;

    h2 {
      font-size: 20px;
    }
  }
`;



const HeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  @media (max-width: 780px) {
    width: 100%;
    display: flex;
    justify-content: space-between;

    p {
      font-size: 10px;
    }
  }
`;
const IconGroup = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;

const LoadingMessage = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #555;
  text-align: center;
  margin: 30px;

  &::after {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 10px;
    border: 2px solid #ccc;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    vertical-align: middle;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;




const Grid = ({ frentes, showGrid, isLoading, total, dataIni, dataFim }) => {

  //===========================TELA CHEIA==============================//
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.log(`Error attempting to enable full - screen mode: ${err.message}(${err.name})`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };





  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...frentes];

    const parseValue = (value) => {
      if (typeof value === 'string') {
        // Remove % se houver, substitui vírgula por ponto, remove espaços
        return parseFloat(value.replace('%', '').replace(',', '.').trim()) || 0;
      }
      return value || 0;
    };

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValueRaw = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValueRaw = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        const aValue = parseValue(aValueRaw);
        const bValue = parseValue(bValueRaw);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [frentes, sortConfig]);



  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };







  //=======================GERAR PDF==========================================//

  const getBase64FromImage = (imgSrc) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve({ base64: canvas.toDataURL("image/png"), width: img.naturalWidth, height: img.naturalHeight });
      };

      img.onerror = () => reject(new Error("Erro ao carregar imagem"));
      img.src = imgSrc;
    });
  };


  const gerarPdfFrentes = async () => {
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "A4" });

    // Marca d'água
    const { base64: marcaDaguaBase64, width: mw, height: mh } = await getBase64FromImage(logo1);
    const maxMarcaW = 400, maxMarcaH = 300;
    const ratioMarca = Math.min(maxMarcaW / mw, maxMarcaH / mh);
    const marcaW = mw * ratioMarca, marcaH = mh * ratioMarca;
    const centerX = (842 - marcaW) / 2, centerY = (595 - marcaH) / 2;

    // Cabeçalho
    const { base64, width, height } = await getBase64FromImage(logo6);
    const maxW = 200, maxH = 60;
    const ratio = Math.min(maxW / width, maxH / height);
    const displayW = width * ratio, displayH = height * ratio;

    doc.addImage(base64, 'PNG', 20, 10, displayW, displayH);
    doc.setFontSize(12);
    doc.setTextColor(87, 87, 87);
    doc.text("Aceitação CDC - Frentes", 30, 70);
    doc.text(`Dados base: ${dataIni} á ${dataFim}`, 600, 70);


    // Cabeçalhos
    const headers = [
      "Frente",
      "Automática",
      "Auto. c/ Alteração",
      "Manual",
      "Sem Lat. Long.",
      "Com Lat. Long. s/ O.C",
      "Com Lat. Long. c/ O.C",
      "Com Lat. Long. c/ O.C c/ Alteração"
    ];

    // Corpo principal
    const body = sortedData.map(item => [
      item.COD_FRENTE,
      item.percentual_automatica,
      item.percentual_automatica_com_alteracao,
      item.percentual_manual,
      item.percentual_sem_lat_long,
      item.percentual_c_lat_long_sem_oc,
      item.percentual_c_lat_long_com_oc,
      item.percentual_c_lat_long_com_oc_com_alt
    ]);

    // Linha total
    total.forEach(item => {
      body.push([
        `Total`,
        item.percentual_automatica,
        item.percentual_automatica_com_alteracao,
        item.percentual_manual,
        item.percentual_sem_lat_long,
        item.percentual_c_lat_long_sem_oc,
        item.percentual_c_lat_long_com_oc,
        item.percentual_c_lat_long_com_oc_com_alt
      ]);
    });

    // Tabela
    autoTable(doc, {
      head: [headers],
      body: body,
      startY: 80,
      margin: { top: 50, left: 20, right: 20 },
      styles: {
        fontSize: 10,
        cellPadding: 4
      },
      headStyles: {
        fillColor: [7, 99, 51],
        textColor: 255
      },
      didDrawPage: () => {
        doc.setGState(new doc.GState({ opacity: 0.08 }));
        doc.addImage(marcaDaguaBase64, 'JPEG', centerX, centerY, marcaW, marcaH);
        doc.setGState(new doc.GState({ opacity: 1 }));
      }
    });

    doc.save(`cdc_frentes_${new Date().toLocaleString("pt-BR")}.pdf`);
  };




  return (
    <>

      <Geral>
        <div>

          {isLoading ? (
            <LoadingMessage>Carregando dados, por favor aguarde...</LoadingMessage>
          ) : (
            <>
              {showGrid && (

                <>
                  <Table>
                    <Thead>
                      <Tr noHover>
                        <CabecalhoTabela colSpan={13}>
                          <HeaderWrapper>
                            <h2 >Frentes</h2>
                            <HeaderRight>
                              <IconGroup>
                                <Button onClick={gerarPdfFrentes} title="Exportar PDF">
                                  Exportar PDF
                                </Button>
                                <Button onClick={toggleFullscreen} title="Tela cheia">
                                  Tela cheia
                                </Button>
                              </IconGroup>
                            </HeaderRight>
                          </HeaderWrapper>
                        </CabecalhoTabela>

                      </Tr>
                    </Thead>

                    <Thead hideOnMobile>

                      <TrHead>
                        <Th onClick={() => onColumnClick("COD_FRENTE")} className={getSortClass("COD_FRENTE")}>
                          Frente {getSortIcon("COD_FRENTE")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_automatica")} className={getSortClass("percentual_automatica")}>
                          Automática {getSortIcon("percentual_automatica")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_automatica_com_alteracao")} className={getSortClass("percentual_automatica_com_alteracao")}>
                          Auto. c/ Alteração {getSortIcon("percentual_automatica_com_alteracao")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_manual")} className={getSortClass("percentual_manual")}>
                          Manual: {getSortIcon("percentual_manual")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_sem_lat_long")} className={getSortClass("percentual_sem_lat_long")}>
                          Sem Lat. Long.: {getSortIcon("percentual_sem_lat_long")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_c_lat_long_sem_oc")} className={getSortClass("percentual_c_lat_long_sem_oc")}>
                          Com Lat. Long. s/ O.C: {getSortIcon("percentual_c_lat_long_sem_oc")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_c_lat_long_sem_oc")} className={getSortClass("percentual_c_lat_long_com_oc")}>
                          Com Lat. Long. c/ O.C: {getSortIcon("percentual_c_lat_long_com_oc")}
                        </Th>
                        <Th onClick={() => onColumnClick("percentual_c_lat_long_sem_oc_com_alt")} className={getSortClass("percentual_c_lat_long_com_oc_com_alt")}>
                          Com Lat. Long. c/ O.C c/ Alteração: {getSortIcon("percentual_c_lat_long_com_oc_com_alt")}
                        </Th>

                      </TrHead>
                    </Thead>

                    <colgroup>
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "14%" }} />
                    </colgroup>

                    <Tbody>
                      {sortedData.map((item, i) => (
                        <Tr key={i}>
                          <Td width="auto" data-label="Frente:">{item.COD_FRENTE}</Td>
                          <Td width="auto" data-label="Automática:">{item.percentual_automatica}</Td>
                          <Td width="auto" data-label="Auto. c/ Alteração:">{item.percentual_automatica_com_alteracao}</Td>
                          <Td width="auto" data-label="Manual:">{item.percentual_manual}</Td>
                          <Td width="auto" data-label="Sem Lat. Long:">{item.percentual_sem_lat_long}</Td>
                          <Td width="auto" data-label="Com Lat. Long. s/ O.C:">{item.percentual_c_lat_long_sem_oc}</Td>
                          <Td width="auto" data-label="Com Lat. Long. c/ O.C:">{item.percentual_c_lat_long_com_oc}</Td>
                          <Td width="auto" data-label="Com Lat. Long. c/ O.C c/ Alteração:">{item.percentual_c_lat_long_com_oc_com_alt}</Td>

                        </Tr>
                      ))
                      }
                    </Tbody>


                  </Table>
                  <Table>

                    <colgroup>
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "10%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "14%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "14%" }} />
                    </colgroup>
                    <Tbody>
                      {total.map((item, i) => (
                        <Tr key={i}>
                          <Td width="auto" data-label="Total:"><strong>{item.TOTAL}</strong></Td>
                          <Td width="auto" data-label="Automática:"><strong>{item.percentual_automatica}</strong></Td>
                          <Td width="auto" data-label="Auto. c/ Alteração:"><strong>{item.percentual_automatica_com_alteracao}</strong></Td>
                          <Td width="auto" data-label="Manual:"><strong>{item.percentual_manual}</strong></Td>
                          <Td width="auto" data-label="Sem Lat. Long:"><strong>{item.percentual_sem_lat_long}</strong></Td>
                          <Td width="auto" data-label="Com Lat. Long. s/ O.C:"><strong>{item.percentual_c_lat_long_sem_oc}</strong></Td>
                          <Td width="auto" data-label="Com Lat. Long. c/ O.C:"><strong>{item.percentual_c_lat_long_com_oc}</strong></Td>
                          <Td width="auto" data-label="Com Lat. Long. c/ O.C c/ Alteração:"><strong>{item.percentual_c_lat_long_com_oc_com_alt}</strong></Td>

                        </Tr>
                      ))
                      }
                    </Tbody>
                  </Table>
                </>
              )}
            </>
          )}






        </div>

      </Geral >

    </>

  );
};



export default Grid;
